export default class BaseNodeInserter {
  constructor(selection) {
    this.selection = selection
  }
}
